import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingAppointments: false,
      currentView: 'current',
      appointments: [],
      appointmentsCount: 0
    }),
    mutations: {
      setLoadingAppointments(state, isLoading) {
        state.loadingAppointments = isLoading;
      },
      setAppointments(state, items) {
        state.appointments = items;
      },
      setAppointmentsCount(state, count) {
        state.appointmentsCount = count;
      },
      setCurrentView(state, view) {
        state.currentView = view;
      },
      updateAppointmentCalledStatus(state, payload) {
        const appointment = state.appointments.find((appt) => {
          return appt.id === payload.supabase_appt_id;
        });

        if (appointment) {
          if (!appointment.note) {
            Vue.set(appointment, 'note', {});
          }

          appointment.note.called = payload.called;
          appointment.note.called_user_id = payload.called_user_id;
          appointment.note.called_user = payload.called_user;
          appointment.note.note_text = payload.note_text;
        }
      }
    },
    actions: {
      async fetchShowroomAppointmentsCount({ commit }) {
        let url = process.env.VUE_APP_HUB_API_HOST + "api/showrooms/appointments/count";

        try {
          const response = await Vue.http.get(url, {
            headers: headers
          });

          commit("setAppointmentsCount", response.body);
        } catch (error) {
          console.log(error);
        }
      },
      async fetchShowroomAppointments({ commit }, payload) {
        commit("setLoadingAppointments", true);
        let url = process.env.VUE_APP_HUB_API_HOST + "api/showrooms/appointments";

        if (payload && payload.view === 'history') {
          url += "/history";
        }

        try {
          const response = await Vue.http.get(url, {
            headers: headers
          });

          commit("setAppointments", response.body);
          commit("setLoadingAppointments", false);
        } catch (error) {
          console.log(error);
          commit("setLoadingAppointments", false);
        }
      },
      async updateAppointmentCalledStatus({ commit }, payload) {
        let url = process.env.VUE_APP_HUB_API_HOST + "api/showrooms/appointments/note";

        try {
          const response = await Vue.http.post(url, payload, {
            headers: headers
          });

          commit("updateAppointmentCalledStatus", payload);

          router.push({
            query: M.toast({
              html: response.data.message,
              classes: "green"
            }),
          });

        } catch (error) {
          console.log(error);
        }
      }
    }
}